/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * Thin wrapper over useBoxSettings that exposes only the feature flags — the
 * long-standing public API `{ features, loading, error }` its consumers depend on.
 * The single box-doc read now lives in useBoxSettings (shared with the timezone).
 */

import { useBoxSettings } from "./useBoxSettings";
import type { BoxFeatures } from "@lemonadetraining/contracts";

interface UseBoxFeaturesResult {
  features: BoxFeatures | null;
  loading: boolean;
  error: Error | null;
}

/**
 * Hook to fetch and cache box features.
 * @param boxID - Box ID to fetch features for
 * @returns Box features, loading state, and error
 */
export const useBoxFeatures = (boxID: string | null | undefined): UseBoxFeaturesResult => {
  const { features, isLoading, error } = useBoxSettings(boxID);
  return { features, loading: isLoading, error };
};
